module.exports = __webpack_public_path__ + "static/media/Send.18225e26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/Send.svg
// module id = 3796
// module chunks = 0